var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	92769: () => (loadSingletonVersion("default", "react", true, [1,18,2,0], () => (() => (__webpack_require__(96540))))),
	59783: () => (loadSingletonVersion("default", "react-dom", true, [1,18,2,0], () => (() => (__webpack_require__(40961))))),
	19655: () => (loadStrictVersion("default", "@datadog/browser-rum", true, [1,6,21,2], () => (() => (__webpack_require__(48953))))),
	96748: () => (loadStrictVersion("default", "html-react-parser", true, [1,5,2,2], () => (() => (__webpack_require__(16649))))),
	54644: () => (loadSingletonVersion("default", "@tanstack/react-query", true, [1,5,100,1], () => (() => (__webpack_require__(85946))))),
	6072: () => (loadSingletonVersion("default", "@emotion/react", true, [1,11,13,3], () => (() => (__webpack_require__(19646))))),
	42989: () => (loadSingletonVersion("default", "@emotion/styled", true, [1,11,14,1], () => (() => (__webpack_require__(71479))))),
	97158: () => (loadSingletonVersion("default", "@mui/x-license", false, [4,8,29,2], () => (__webpack_require__.e(9478).then(() => (() => (__webpack_require__(29478))))))),
	21816: () => (loadSingletonVersion("default", "dayjs", true, [1,1,11,13], () => (() => (__webpack_require__(74353))))),
	17826: () => (loadSingletonVersion("default", "date-fns/format", true, [1,4,1,0], () => (() => (__webpack_require__(96220))))),
	1254: () => (loadSingletonVersion("default", "react-router", true, [1,7,18,2], () => (() => (__webpack_require__(95632))))),
	3434: () => (loadSingletonVersion("default", "date-fns/locale/en-US", true, [1,4,1,0], () => (() => (__webpack_require__(20990))))),
	6814: () => (loadSingletonVersion("default", "date-fns/startOfWeek", true, [1,4,1,0], () => (() => (__webpack_require__(23480))))),
	9593: () => (loadSingletonVersion("default", "@mui/x-date-pickers", true, [1,8,19,0], () => (() => (__webpack_require__(163))))),
	11987: () => (loadSingletonVersion("default", "@cocounsel/harmonia", true, [1,1,2,1], () => (() => (__webpack_require__(32025))))),
	12748: () => (loadSingletonVersion("default", "date-fns/addMonths", true, [1,4,1,0], () => (() => (__webpack_require__(53521))))),
	12955: () => (loadSingletonVersion("default", "@openfeature/react-sdk", true, [2,0,4,11], () => (() => (__webpack_require__(89663))))),
	14718: () => (loadStrictVersion("default", "axios", false, [1,1,20,0], () => (__webpack_require__.e(8396).then(() => (() => (__webpack_require__(38396))))))),
	15810: () => (loadSingletonVersion("default", "date-fns/isWithinInterval", true, [1,4,1,0], () => (() => (__webpack_require__(12343))))),
	17945: () => (loadStrictVersion("default", "react-i18next", false, [1,14,1,0], () => (__webpack_require__.e(2365).then(() => (() => (__webpack_require__(62365))))))),
	20062: () => (loadSingletonVersion("default", "date-fns/startOfDay", true, [1,4,1,0], () => (() => (__webpack_require__(86436))))),
	21058: () => (loadSingletonVersion("default", "date-fns/isBefore", true, [1,4,1,0], () => (() => (__webpack_require__(39474))))),
	29202: () => (loadSingletonVersion("default", "date-fns/addWeeks", true, [1,4,1,0], () => (() => (__webpack_require__(37177))))),
	30024: () => (loadSingletonVersion("default", "date-fns/startOfYear", true, [1,4,1,0], () => (() => (__webpack_require__(92561))))),
	31170: () => (loadSingletonVersion("default", "date-fns/addSeconds", true, [1,4,1,0], () => (() => (__webpack_require__(50105))))),
	34358: () => (loadSingletonVersion("default", "date-fns/setHours", true, [1,4,1,0], () => (() => (__webpack_require__(44378))))),
	37137: () => (loadStrictVersion("default", "react-idle-timer", false, [1,5,7,2], () => (__webpack_require__.e(7087).then(() => (() => (__webpack_require__(7087))))))),
	37920: () => (loadSingletonVersion("default", "date-fns/isSameDay", true, [1,4,1,0], () => (() => (__webpack_require__(51189))))),
	41632: () => (loadSingletonVersion("default", "date-fns/getMilliseconds", true, [1,4,1,0], () => (() => (__webpack_require__(83895))))),
	41958: () => (loadSingletonVersion("default", "date-fns/getDaysInMonth", true, [1,4,1,0], () => (() => (__webpack_require__(45343))))),
	45006: () => (loadSingletonVersion("default", "date-fns/endOfMonth", true, [1,4,1,0], () => (() => (__webpack_require__(72923))))),
	45094: () => (loadSingletonVersion("default", "date-fns/setMinutes", true, [1,4,1,0], () => (() => (__webpack_require__(96764))))),
	45296: () => (loadSingletonVersion("default", "date-fns/setDate", true, [1,4,1,0], () => (() => (__webpack_require__(2217))))),
	46462: () => (loadSingletonVersion("default", "date-fns/setMonth", true, [1,4,1,0], () => (() => (__webpack_require__(67075))))),
	47988: () => (loadSingletonVersion("default", "date-fns/isEqual", true, [1,4,1,0], () => (() => (__webpack_require__(3173))))),
	48173: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(2485).then(() => (() => (__webpack_require__(32485))))))),
	53638: () => (loadSingletonVersion("default", "zustand", true, [1,4,5,2], () => (() => (__webpack_require__(34085))))),
	53734: () => (loadSingletonVersion("default", "date-fns/addYears", true, [1,4,1,0], () => (() => (__webpack_require__(14026))))),
	54673: () => (loadSingletonVersion("default", "zone.js", false, [2,0,14,3], () => (__webpack_require__.e(8216).then(() => (() => (__webpack_require__(38216))))))),
	56950: () => (loadSingletonVersion("default", "date-fns/getHours", true, [1,4,1,0], () => (() => (__webpack_require__(7886))))),
	60322: () => (loadSingletonVersion("default", "date-fns/isSameHour", true, [1,4,1,0], () => (() => (__webpack_require__(82729))))),
	61798: () => (loadSingletonVersion("default", "date-fns/endOfYear", true, [1,4,1,0], () => (() => (__webpack_require__(6396))))),
	62230: () => (loadSingletonVersion("default", "date-fns/addMinutes", true, [1,4,1,0], () => (() => (__webpack_require__(77317))))),
	62986: () => (loadStrictVersion("default", "sanitize-html", false, [1,2,17,7], () => (Promise.all([__webpack_require__.e(4728), __webpack_require__.e(7172)]).then(() => (() => (__webpack_require__(74728))))))),
	63588: () => (loadStrictVersion("default", "react-hook-form", false, [1,7,73,1], () => (__webpack_require__.e(7286).then(() => (() => (__webpack_require__(97286))))))),
	64036: () => (loadSingletonVersion("default", "date-fns/getWeek", true, [1,4,1,0], () => (() => (__webpack_require__(3301))))),
	64281: () => (load("default", "@cocounsel/mytikas-mfe-client", false, () => (__webpack_require__.e(9711).then(() => (() => (__webpack_require__(19711))))))),
	66862: () => (loadSingletonVersion("default", "date-fns/getMonth", true, [1,4,1,0], () => (() => (__webpack_require__(39159))))),
	66894: () => (loadSingletonVersion("default", "date-fns/startOfMonth", true, [1,4,1,0], () => (() => (__webpack_require__(47876))))),
	67370: () => (loadSingletonVersion("default", "date-fns/parse", true, [1,4,1,0], () => (() => (__webpack_require__(45660))))),
	67868: () => (loadStrictVersion("default", "usehooks-ts", false, [1,3,1,0], () => (__webpack_require__.e(5103).then(() => (() => (__webpack_require__(65103))))))),
	69360: () => (loadSingletonVersion("default", "date-fns/isValid", true, [1,4,1,0], () => (() => (__webpack_require__(86559))))),
	77778: () => (loadSingletonVersion("default", "date-fns/isSameYear", true, [1,4,1,0], () => (() => (__webpack_require__(30626))))),
	78626: () => (loadSingleton("default", "@cocounsel/prometheus", true, () => (() => (__webpack_require__(33950))))),
	78721: () => (loadStrictVersion("default", "@saffron/core-components", false, [1,3,0,0], () => (__webpack_require__.e(1997).then(() => (() => (__webpack_require__(21997))))))),
	82834: () => (loadSingletonVersion("default", "date-fns/endOfDay", true, [1,4,1,0], () => (() => (__webpack_require__(52055))))),
	83358: () => (loadSingletonVersion("default", "date-fns/setYear", true, [1,4,1,0], () => (() => (__webpack_require__(8228))))),
	84004: () => (loadSingletonVersion("default", "date-fns/endOfWeek", true, [1,4,1,0], () => (() => (__webpack_require__(10745))))),
	84400: () => (loadSingletonVersion("default", "date-fns/addDays", true, [1,4,1,0], () => (() => (__webpack_require__(60153))))),
	86428: () => (loadSingletonVersion("default", "date-fns/isAfter", true, [1,4,1,0], () => (() => (__webpack_require__(66299))))),
	91592: () => (loadSingletonVersion("default", "date-fns/getDate", true, [1,4,1,0], () => (() => (__webpack_require__(52653))))),
	92502: () => (loadSingletonVersion("default", "date-fns/getSeconds", true, [1,4,1,0], () => (() => (__webpack_require__(33632))))),
	92820: () => (loadSingletonVersion("default", "date-fns/isSameMonth", true, [1,4,1,0], () => (() => (__webpack_require__(66793))))),
	93118: () => (loadSingletonVersion("default", "date-fns/getYear", true, [1,4,1,0], () => (() => (__webpack_require__(13720))))),
	94341: () => (loadStrictVersion("default", "js-cookie", false, [1,3,0,8], () => (__webpack_require__.e(5468).then(() => (() => (__webpack_require__(35468))))))),
	97392: () => (loadSingletonVersion("default", "date-fns/setMilliseconds", true, [1,4,1,0], () => (() => (__webpack_require__(40755))))),
	97870: () => (loadSingletonVersion("default", "date-fns/getMinutes", true, [1,4,1,0], () => (() => (__webpack_require__(57912))))),
	98283: () => (loadSingleton("default", "@cocounsel/prometheus/material", true, () => (() => (__webpack_require__(14141))))),
	99454: () => (loadSingletonVersion("default", "date-fns/addHours", true, [1,4,1,0], () => (() => (__webpack_require__(34215))))),
	99742: () => (loadSingletonVersion("default", "date-fns/setSeconds", true, [1,4,1,0], () => (() => (__webpack_require__(44780))))),
	82723: () => (loadSingletonVersion("default", "@mui/x-data-grid", false, [1,8,29,2], () => (__webpack_require__.e(3396).then(() => (() => (__webpack_require__(63396))))))),
	89143: () => (loadSingletonVersion("default", "@mui/x-data-grid-pro", false, [1,8,29,2], () => (__webpack_require__.e(7818).then(() => (() => (__webpack_require__(7818))))))),
	55593: () => (loadSingletonVersion("default", "date-fns", true, [1,4,1,0], () => (() => (__webpack_require__(11498))))),
	14791: () => (loadStrictVersion("default", "postcss", false, [1,8,2,1], () => (Promise.all([__webpack_require__.e(2418), __webpack_require__.e(1445)]).then(() => (() => (__webpack_require__(2418))))))),
	75331: () => (loadSingletonVersion("default", "@mui/x-data-grid-premium", false, [1,8,29,2], () => (Promise.all([__webpack_require__.e(2257), __webpack_require__.e(123), __webpack_require__.e(5923), __webpack_require__.e(2723), __webpack_require__.e(9143)]).then(() => (() => (__webpack_require__(25923))))))),
	3555: () => (loadSingletonVersion("default", "date-fns/compareDesc", true, [1,4,1,0], () => (() => (__webpack_require__(60451))))),
	6883: () => (loadSingletonVersion("default", "date-fns-tz", false, [1,3,2,0], () => (Promise.all([__webpack_require__.e(3797), __webpack_require__.e(5593)]).then(() => (() => (__webpack_require__(13797))))))),
	19873: () => (loadStrictVersion("default", "@cocounsel/basenji", false, [2,0,12,5], () => (__webpack_require__.e(7667).then(() => (() => (__webpack_require__(97667))))))),
	81238: () => (loadSingletonVersion("default", "date-fns/parseISO", true, [1,4,1,0], () => (() => (__webpack_require__(55137))))),
	82129: () => (loadStrictVersion("default", "react-virtuoso", false, [1,4,18,1], () => (__webpack_require__.e(5778).then(() => (() => (__webpack_require__(35778))))))),
	88382: () => (loadSingletonVersion("default", "date-fns/addMilliseconds", true, [1,4,1,0], () => (() => (__webpack_require__(29244))))),
	92363: () => (loadStrictVersion("default", "uuid", false, [1,11,1,0], () => (__webpack_require__.e(3419).then(() => (() => (__webpack_require__(93419))))))),
	2054: () => (loadStrictVersion("default", "react-use-measure", false, [1,2,1,1], () => (__webpack_require__.e(4688).then(() => (() => (__webpack_require__(34688))))))),
	59048: () => (loadStrictVersion("default", "react-resizable-panels", false, [1,3,0,6], () => (__webpack_require__.e(3722).then(() => (() => (__webpack_require__(23722))))))),
	53989: () => (loadStrictVersion("default", "powerbi-client-react", false, [1,1,4,0], () => (__webpack_require__.e(3164).then(() => (() => (__webpack_require__(93164)))))))
};
var initialConsumes = [92769,59783,19655,96748,54644,6072,42989];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"1816": [
		21816
	],
	"2054": [
		2054
	],
	"2723": [
		82723
	],
	"3864": [
		3555,
		6883,
		19873,
		81238,
		82129,
		88382,
		92363
	],
	"3989": [
		53989
	],
	"4333": [
		59048
	],
	"5331": [
		75331
	],
	"5593": [
		55593
	],
	"6651": [
		1254,
		3434,
		6814,
		9593,
		11987,
		12748,
		12955,
		14718,
		15810,
		17945,
		20062,
		21058,
		29202,
		30024,
		31170,
		34358,
		37137,
		37920,
		41632,
		41958,
		45006,
		45094,
		45296,
		46462,
		47988,
		48173,
		53638,
		53734,
		54673,
		56950,
		60322,
		61798,
		62230,
		62986,
		63588,
		64036,
		64281,
		66862,
		66894,
		67370,
		67868,
		69360,
		77778,
		78626,
		78721,
		82834,
		83358,
		84004,
		84400,
		86428,
		91592,
		92502,
		92820,
		93118,
		94341,
		97392,
		97870,
		98283,
		99454,
		99742
	],
	"7158": [
		97158
	],
	"7172": [
		14791
	],
	"7826": [
		17826
	],
	"8792": [
		92769,
		59783,
		19655,
		96748,
		54644,
		6072,
		42989
	],
	"9143": [
		89143
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}